import api from "crqlar-react-common/dist/services/api";
import type {
    InsightTargetSelectionUpdateV4,
    InsightTargetPeriodV4,
    InsightTargetsUpdateV4,
} from "../models/crm-v4";

export class InsightTargetV4Service {
    private static baseUrl = "/v3/insights/v4/targets/crm";

    static async list(): Promise<InsightTargetPeriodV4[]> {
        const response = await api.get<InsightTargetPeriodV4[]>(InsightTargetV4Service.baseUrl);
        return response.data;
    }

    static async save(request: InsightTargetsUpdateV4): Promise<InsightTargetPeriodV4[]> {
        const response = await api.put<InsightTargetPeriodV4[]>(InsightTargetV4Service.baseUrl, request);
        return response.data;
    }

    static async select(request: InsightTargetSelectionUpdateV4): Promise<InsightTargetPeriodV4[]> {
        const response = await api.put<InsightTargetPeriodV4[]>(`${InsightTargetV4Service.baseUrl}/active`, request);
        return response.data;
    }

    static async remove(from: string, to: string): Promise<InsightTargetPeriodV4[]> {
        const response = await api.delete<InsightTargetPeriodV4[]>(
            `${InsightTargetV4Service.baseUrl}/${from}/${to}`,
        );
        return response.data;
    }

    static async removeAll(): Promise<InsightTargetPeriodV4[]> {
        const response = await api.delete<InsightTargetPeriodV4[]>(InsightTargetV4Service.baseUrl);
        return response.data;
    }
}
